

<div class="container-fluid">
  <div class="
    stepper stepper-pills stepper-column
    d-flex
    flex-column flex-xl-row flex-row-fluid "
       id="kt_create_account_stepper">
    <div class="
      d-flex
      justify-content-center
      rounded
      justify-content-xl-start
      flex-row-auto
     
      me-9
      card
    ">
      <div class="card-body px-6 px-lg-10 px-xxl-15 py-20">
        <div class="stepper-nav">
          <div class="stepper-item"
               [ngClass]="{
            current: currentStep$.value === 1 }">
            <div class="stepper-line w-40px"></div>

            <div class="stepper-icon w-40px h-40px">
              <i class="stepper-check fas fa-check"></i>
              <span class="stepper-number">1</span>
            </div>

            <div class="stepper-label">
              <h3 class="stepper-title">{{utilityService.getResourceValue("ActiveDirectory")}}</h3>

              <div class="stepper-desc fw-bold">{{utilityService.getResourceValue("ActiveDirectory_Tab1Note")}}</div>
            </div>
          </div>

          <div class="stepper-item"
               [ngClass]="{
            current: currentStep$.value === 2 }">
            <div class="stepper-line w-40px"></div>

            <div class="stepper-icon w-40px h-40px">
              <i class="stepper-check fas fa-check"></i>
              <span class="stepper-number">2</span>
            </div>

            <div class="stepper-label">
              <h3 class="stepper-title">{{utilityService.getResourceValue("ActiveDirectory_SelectContainer")}}</h3>
              <div class="stepper-desc fw-bold">{{utilityService.getResourceValue("ActiveDirectory_Tab2Note")}}</div>
            </div>
          </div>

          <div class="stepper-item"
               [ngClass]="{
            current: currentStep$.value === 3}">
            <div class="stepper-line w-40px"></div>

            <div class="stepper-icon w-40px h-40px">
              <i class="stepper-check fas fa-check"></i>
              <span class="stepper-number">3</span>
            </div>

            <div class="stepper-label">
              <h3 class="stepper-title">{{utilityService.getResourceValue("Options")}}</h3>
              <div class="stepper-desc fw-bold">{{utilityService.getResourceValue("ActiveDirectory_Tab3Note")}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card d-flex flex-row-fluid flex-center  rounded">
      <form class="p-20 w-100 card-body"
            id="kt_create_account_form" [formGroup]="AddActiveDirectoryForm">
        <div class="current" *ngIf="IsAddFormLoaded">
          <ng-container *ngIf="currentStep$.value === 1">
            <div class="form-group mb-10">
                <BBSF-DropdownList [options]="AddTypeOptions" [group]="AddActiveDirectoryForm" (OnChange)="typeChange($event)">
                </BBSF-DropdownList>
            </div>
            <div class="form-group mb-10">
              <BBSF-TextBox [options]="AddDomain" [group]="AddActiveDirectoryForm">
              </BBSF-TextBox>
            </div>
            <div class="form-group mb-10">
              <BBSF-TextBox [options]="AddSamAccount" [group]="AddActiveDirectoryForm">
              </BBSF-TextBox>
            </div>
            <div class="form-group mb-10">
              <BBSF-TextBox [options]="AddPassword" [group]="AddActiveDirectoryForm">
              </BBSF-TextBox>
            </div>
            <div class="form-group mb-10" *ngIf="AddShowBuiltInGroupsVisible">
              <BBSF-Toggleslide [options]="AddShowBuiltInGroups" [group]="AddActiveDirectoryForm">
              </BBSF-Toggleslide>
            </div>
          </ng-container>
          <ng-container *ngIf="currentStep$.value === 2">
            <div class="form-group mb-10">
              <BBSF-TextBox [options]="AddSearchTree" [group]="AddActiveDirectoryForm"></BBSF-TextBox>
            </div>
          </ng-container>

          <ng-container *ngIf="currentStep$.value === 3">
            <div class="form-group">
              <BBSF-TextBox [options]="AddName" [group]="AddActiveDirectoryForm">
              </BBSF-TextBox>
            </div>
            <div class="form-group mb-10">
              <BBSF-DropdownList [options]="AddPermissionSet" [group]="AddActiveDirectoryForm">
              </BBSF-DropdownList>
            </div>
            <div class="form-group mb-10">
              <BBSF-DropdownList [options]="AddLanguage" [group]="AddActiveDirectoryForm">
              </BBSF-DropdownList>
            </div>
            <div class="form-group mb-10">
              <BBSF-DropdownList [options]="AddWelcomeMsgTemp" [group]="AddActiveDirectoryForm">
              </BBSF-DropdownList>
            </div>
            <div class="form-group mb-10">
              <BBSF-DropdownList [options]="AddFileProvider" [group]="AddActiveDirectoryForm">
              </BBSF-DropdownList>
            </div>
            <div class="form-group mb-10">
              <BBSF-Toggleslide [options]="AddMarkInactive" [group]="AddActiveDirectoryForm">
              </BBSF-Toggleslide>
            </div>
            <div class="form-group mb-10">
              <BBSF-Toggleslide [options]="AddDailyJob" [group]="AddActiveDirectoryForm">
              </BBSF-Toggleslide>
            </div>
            <div class="table-responsive">
              <!-- begin::Table -->
              <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer table-w-control">
                <thead>
                  <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                    <th class="min-w-150px">{{utilityService.getResourceValue("Type")}}</th>
                    <th class="min-w-150px">{{utilityService.getResourceValue("Property")}}</th>
                    <th class="min-w-150px">{{utilityService.getResourceValue("ADProperty")}}</th>
                    <th class="min-w-150px">{{utilityService.getResourceValue("IncludeInUpdate")}}</th>
                    <th class="min-w-50px"></th>
                  </tr>
                </thead>
                <tbody class="fw-bold text-gray-600 border-0">
                  <tr *ngFor="let option of AddMappingsOptions;let i=index;">
                    <td>
                      <BBSF-DropdownList [options]="option[0]" [group]="AddActiveDirectoryForm">
                      </BBSF-DropdownList>
                    </td>
                    <td>
                      <BBSF-DropdownList [options]="option[1]" [group]="AddActiveDirectoryForm">
                      </BBSF-DropdownList>
                    </td>
                    <td>
                      <BBSF-TextBox [options]="option[2]" [group]="AddActiveDirectoryForm">
                      </BBSF-TextBox>
                    </td>
                    <td>
                      <BBSF-CheckBox [options]="option[3]" [group]="AddActiveDirectoryForm">
                      </BBSF-CheckBox>
                    </td>

                    <td>
                      <a class="btn btn-icon btn-light-danger" (click)="deleteADMapping(option)">
                        <i class=" fa fa-trash hidden" aria-hidden="true"></i>
                      </a>
                    </td>
                  </tr>

                </tbody>
              </table>

            </div>
          </ng-container>
        </div>

        <div class="d-flex flex-stack pt-10">
          <div class="mr-2">
            <ng-container *ngIf="currentStep$.value !== 1">
              <button type="button"
                      class="btn btn-lg btn-light-primary me-3"
                      (click)="prevStep()">
                <span [inlineSVG]="'./src/assets/images/arr063.svg'"
                      class="svg-icon svg-icon-4 me-1"></span>
                {{utilityService.getResourceValue("Previous")}}
              </button>
            </ng-container>
          </div>
          <ng-container *ngIf="currentStep$.value !== formsCount">
            <div>
              <button type="button"
                      class="btn btn-lg btn-primary me-3"
                      (click)="nextStep()">
                <span class="indicator-label">
                  <ng-container *ngIf="currentStep$.value < formsCount">
                    {{utilityService.getResourceValue("Next")}} {{ " " }}
                    <span [inlineSVG]="
                      './src/assets/images/arr064.svg'
                    "
                          class="svg-icon svg-icon-3 ms-2 me-0"></span>
                  </ng-container>
                 
                </span>
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="currentStep$.value === formsCount" >
            <button type="button"
                    class="btn btn-lg btn-primary me-3"
                    (click)="onSubmit()">
              {{utilityService.getResourceValue("Submit")}}
            </button>
           
          </ng-container>
        </div>
      </form>
    </div>
  </div>



</div>
